import script from "./equityFunds.vue?vue&type=script&setup=true&lang=js"
export * from "./equityFunds.vue?vue&type=script&setup=true&lang=js"

import "./equityFunds.vue?vue&type=style&index=0&id=33d7fdce&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d7fdce"]])

export default __exports__